import * as React from "react";
import { forwardRef, memo } from "react";
const SvgLu = ({
  title,
  titleId,
  ...props
}, ref) => /* @__PURE__ */ React.createElement("svg", { xmlns: "http://www.w3.org/2000/svg", viewBox: "0 0 10 6", ref, "aria-labelledby": titleId, ...props }, title ? /* @__PURE__ */ React.createElement("title", { id: titleId }, title) : null, /* @__PURE__ */ React.createElement("path", { fill: "#00A3E0", d: "M0 3h10v3H0z" }), /* @__PURE__ */ React.createElement("path", { fill: "#EF3340", d: "M0 0h10v3H0z" }), /* @__PURE__ */ React.createElement("path", { fill: "#fff", d: "M0 2h10v2H0z" }));
const ForwardRef = forwardRef(SvgLu);
const Memo = memo(ForwardRef);
export default Memo;
